module.exports = __webpack_public_path__ + "img/BGFeatureMediaLayered.ae5b3a49.jpg";